import React from 'react';
import { Redirect } from 'react-router-dom';

import { locationsURL } from './routes';

export const Route = () => {
  return <Redirect to={locationsURL()} />;
};
